"use strict";
var appn;
(function (appn) {
    var services;
    (function (services) {
        function validateDateFormat(value, resultLabel) {
            resultLabel.html(appn.ui.getSpinner());
            appn.ajax.post({
                url: appn.urls.services.ajaxValidateDateFormat,
                data: { format: value },
                dataType: 'json',
                done: function (data) {
                    if (data) {
                        resultLabel.html(data);
                        return;
                    }
                    resultLabel.html(`<span class="badge label-danger">${T('Unable to validate.')}</span>`);
                },
                fail: function () {
                    resultLabel.html(`<span class="badge label-danger">${T('Unable to validate.')}</span>`);
                }
            });
        }
        services.validateDateFormat = validateDateFormat;
        function pingPlatform() {
            appn.ajax.get({
                url: appn.urls.services.ajaxPing,
                done: function (data, textStatus, jqXHR) {
                    appn.ui.validateSessionFromAjax(jqXHR);
                }
            });
        }
        services.pingPlatform = pingPlatform;
        function startPingTimer() {
            setInterval(function () {
                pingPlatform();
            }, 60000 * 5);
        }
        services.startPingTimer = startPingTimer;
        function findLocationFromAddress(address, onSuccessCallback) {
            appn.ajax.get({
                url: appn.urls.services.ajaxFindLocation,
                data: { address: address },
                done: function (data) {
                    onSuccessCallback(data);
                },
                fail: function () {
                    appn.dialog.alert({
                        modalColor: 'modal-danger',
                        title: T('Address Lookup Failed'),
                        message: T('Something went wrong when attempting to find the location data.'),
                        buttons: {
                            ok: {
                                label: '<span>' + T('OK') + '</span>',
                                className: 'btn-success'
                            }
                        },
                        autoHeaderIcon: false
                    });
                }
            });
        }
        services.findLocationFromAddress = findLocationFromAddress;
    })(services = appn.services || (appn.services = {}));
})(appn || (appn = {}));
